import { render, staticRenderFns } from "./realDataManage.vue?vue&type=template&id=e285b4f6"
import script from "./realDataManage.vue?vue&type=script&lang=js"
export * from "./realDataManage.vue?vue&type=script&lang=js"
import style0 from "./realDataManage.vue?vue&type=style&index=0&id=e285b4f6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports